import { inject, Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISearchAoTBalanceCriteria } from '@app/core/models/searchAoTBalanceCriteria.model';
import { AoTResultDTO } from '@app/core/models/aotGridResultLineDTO.model';
import { IEntityForecastVolumeResponseDTO } from '@app/core/models/entity-forecast-volume.model';
import { Guid } from 'guid-typescript';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { AoTUserSettingTemplateComponent } from '@app/features/aot/aot-usersetting-template/aot-usersetting-template.component';

@Injectable({
  providedIn: 'root',
})
export class AoTBalanceService {
  private readonly http = inject(HttpClient);
  private readonly dialogService = inject(DialogService);
  constructor() {}

  searchAoTBalance(sc: ISearchAoTBalanceCriteria): Observable<AoTResultDTO> {
    let params = new HttpParams();

    sc.entityGroupIndexes?.forEach(element => {
      params = params.append('entityGroupIndexes', element.toString());
    });

    params = params
      .set('periodTypeId', sc.period.periodType)
      .set('periodCount', sc.period.periodCount.toString())
      .set('groupingId', sc.groupingId.toString())
      .set('unitCode', sc.unitCode)
      .set('date', sc.date)
      .set('parentGroupText', sc.parentGroupText ?? '')
      .set('isChildRequest', sc.isChildRequest);

    sc.siteIds?.forEach(element => {
      params = params.append('siteIds', element.toString());
    });

    sc.transTypeMainId?.forEach(element => {
      params = params.append('TransTypeMainId', element.toString());
    });

    sc.transTypeSecondaryId?.forEach(element => {
      params = params.append('transTypeSecondaryId', element.toString());
    });
    sc.groupingPath?.forEach(element => {
      params = params.append('groupingPath', element.toString());
    });

    if (sc.parentGroupNumber) {
      params = params.set('parentGroupNumber', sc.parentGroupNumber);
    }

    if (sc.parentGroupingId !== null && sc.parentGroupingId !== undefined) {
      params = params.set('parentGroupingId', sc.parentGroupingId.toString());
    }

    if (sc.parentGroupingId2 !== null && sc.parentGroupingId2 !== undefined) {
      params = params.set('parentGroupingId2', sc.parentGroupingId2.toString());
    }

    if (sc.parentGroupText2 !== null && sc.parentGroupText2 !== undefined) {
      params = params.set('parentGroupText2', sc.parentGroupText2);
    }

    if (sc.parentGroupNumber2 !== null && sc.parentGroupNumber2 !== undefined) {
      params = params.set('parentGroupNumber2', sc.parentGroupNumber2.toString());
    }

    return this.http.get<AoTResultDTO>(`${environment.apiUrl}aot/balance`, { params });
  }

  getActivityMaterialForecastVolume(activityIndex: number, date: Date, siteId: Guid): Observable<IEntityForecastVolumeResponseDTO[]> {
    const params = new HttpParams().set('date', date.toISOString()).set('activityIndex', activityIndex.toString()).set('siteId', siteId.toString());

    return this.http.get<IEntityForecastVolumeResponseDTO[]>(`${environment.apiUrl}aot/balance/material-forecast`, { params });
  }

  openDialog(): DialogRef {
    const dialogRef = this.dialogService.open({
      content: AoTUserSettingTemplateComponent,
      width: '500px',
      height: 'auto',
      themeColor: 'primary',
    });

    return dialogRef;
  }
}
